import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.templateGenerationSettingsComponentState || initialState;

export const selectTemplateGenerationSettings = createSelector(
  [selectDomain],
  state => state.templateGenerationSettings,
);
